import { getCookie } from '@chilecompra/react-kit/storages'
import { makeActionCreator } from '../../config/store/utils'
import { getAuthToken } from '../../services/auth'
import { getFrameworks, getInitialConfig, getLastUpdate } from '../../services/config'
import { DEFAULT_PROVIDERS_FRAMEWORK_INDICATOR, REGIONS_ALL } from '../../config/settings/constants'
export const GET_INITIAL_CONFIG = 'GET_INITIAL_CONFIG'
export const GET_INITIAL_CONFIG_ERROR = 'GET_INITIAL_CONFIG_ERROR'
export const GET_INITIAL_CONFIG_SUCCESS = 'GET_INITIAL_CONFIG_SUCCESS'
export const onGetInitialConfig = makeActionCreator(GET_INITIAL_CONFIG)
export const onGetInitialConfigError = makeActionCreator(GET_INITIAL_CONFIG_ERROR, 'payload')
export const onGetInitialConfigSuccess = makeActionCreator(GET_INITIAL_CONFIG_SUCCESS, 'payload')
export const onGetInitialConfigThunk = () => async dispatch => {
  dispatch(onGetInitialConfig())

  try {
    const accessToken = getCookie('access_token')

    if (!accessToken) {
      await getAuthToken()
    }

    const [{ data: configData }, { data: updateData }, { data: frameworksData }] = await Promise.all([
      getInitialConfig(),
      getLastUpdate(),
      getFrameworks({ year: DEFAULT_PROVIDERS_FRAMEWORK_INDICATOR.year })
    ])
    const [{ modality: modalities, regions, sectors, years }] = configData.payload
    const frameworksPayload = frameworksData.payload
    return dispatch(
      onGetInitialConfigSuccess({
        endYear: years.endYear,
        frameworks: frameworksPayload.map(item => ({ id: item.id, name: item.frameworkAgreement, value: item.id })),
        latestUpdate: updateData.payload,
        modalities: modalities.map(modality => ({ id: modality.id, name: modality.name, value: modality.id })),
        regions: [
          { id: REGIONS_ALL, name: 'Todas las regiones', value: REGIONS_ALL },
          ...regions.map(region => ({ id: region.id, name: region.name, value: region.id }))
        ],
        sectors: sectors.map(sector => ({ id: sector.id, name: sector.name, value: sector.id })),
        startYear: years.startYear
      })
    )
  } catch (error) {
    return dispatch(onGetInitialConfigError({ error }))
  }
}
